import React, { useEffect, useState } from "react";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import { Notifier } from "../../ecosystem";

const VideoVisitBrowserMsgs = ({
    ssoBaseUrl
}) => {

    const [linkProps, setLinkProps] = useState({});
    const IPHONE_APP_URL = `${ssoBaseUrl}app_download/iphone`;
    const GOOGLE_PLAY_URL = `${ssoBaseUrl}app_download/android`;
    const isMobile = Tools.isMobile();
    const android = Tools.isAndroid();
    const ios = Tools.isIos();
    const currentBrowserName = Tools.browserDetection();
    const mobileBrowserName = currentBrowserName ? `${ios ? "ios" : android ? "android" : ""} ${currentBrowserName}` : '';

    useEffect(() => {
        setLink();
        return () => { }
    }, [currentBrowserName]);

    const downloadiOSMobileApp = () => {
        //DOWNLOAD APP BUTTON THAT DIRECTS USER TO CORRESPONDING APP STORE TO DOWNLOAD APP 
        if (typeof window !== 'undefined')
            window.location.href = IPHONE_APP_URL;
        logUI('MBHWeb.Dashboard.AppointmentTile.VideoVisit.iTunes.Redirect', new Date(), '/iTunesDownload');
    }

    const downloadAndroidMobileApp = () => {
        //DOWNLOAD APP BUTTON THAT DIRECTS USER TO CORRESPONDING PLAY STORE TO DOWNLOAD APP 
        if (typeof window !== 'undefined')
            window.location.href = GOOGLE_PLAY_URL;
        logUI('MBHWeb.Dashboard.AppointmentTile.VideoVisit.GooglePlay.Redirect', new Date(), '/GooglePlayDownload');
    }

    const setLink = () => {
        if (android) {
            setLinkProps({
                label: "Download the app",
                href: "https://play.google.com/store/apps/details?id=com.baylorscottandwhite.healthsource&hl=en_US",
                onClick: downloadAndroidMobileApp,
                target: "_blank"
            });
        } else if (ios) {
            setLinkProps({
                label: "Download the app",
                href: "https://itunes.apple.com/us/app/mybswhealth/id1000856979?mt=8",
                onClick: downloadiOSMobileApp,
                target: "_blank"
            });
        } else if (currentBrowserName === "Edge") {
            setLinkProps({
                label: "Upgrade Edge",
                href: "https://www.microsoft.com/en-us/edge",
                onClick: () => logUI("MBHWeb.Dashboard.AppointmentTile.UpgradeEdge.Click", new Date(), Tools.getURLPath()),
                target: "_blank"
            });
        } else {
            setLinkProps({
                label: "Download Google Chrome",
                href: "https://www.google.com/chrome/",
                onClick: () => logUI("MBHWeb.Dashboard.AppointmentTile.DownloadChrome.Click", new Date(), Tools.getURLPath()),
                target: "_blank"
            })
        }
    }

    return (
        <div className="appt-tile__browser-msg">
            <Notifier
                link={linkProps}
            >
                {isMobile ? "You need MyBSWHealth app to proceed with your video visit."
                    : currentBrowserName === "Edge"
                        ? "Your version of Edge needs to be upgraded to proceed with your video visit."
                        : "You need a different browser to proceed with your video visit."
                }
            </Notifier>
        </div>);
}

export default VideoVisitBrowserMsgs;
